import { ReferralBonusTypes } from "../types";

export function isActivationTypeReferral(referralProgram: ReferralBonusTypes) {
  return [ReferralBonusTypes.FLEX_ACTIVATION_OR_HIRING, ReferralBonusTypes.ACTIVATION].includes(
    referralProgram
  );
}
